export { default } from './LocaleService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/services/LocaleService/index.js